export const inspectRequestConstants = {
  GET_REQUEST: "GET_INSPECTREQUEST_REQUEST",
  GET_SUCCESS: "GET_INSPECTREQUEST_SUCCESS",
  GET_FAILURE: "GET_INSPECTREQUEST_FAILURE",
};
